import client from './client'

export const fetchWorkStatus = () => {
  return client.get('/api/v1/work_status')
}